/**
 * i18next Initialization - KEIKKA v8.0
 * 
 * Syncs i18next with the unified LocaleManager.
 * All 7 supported languages loaded.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import et from './locales/et.json';
import fi from './locales/fi.json';
import sv from './locales/sv.json';
import nb from './locales/nb.json';
import ru from './locales/ru.json';
import es from './locales/es.json';

import { 
  getLocale, 
  TIER_A_LANGUAGES,
  FALLBACK_LANGUAGE,
} from './localeManager';

// Build resources for all supported languages
const resources = {
  en: { translation: en },
  et: { translation: et },
  fi: { translation: fi },
  sv: { translation: sv },
  nb: { translation: nb },
  ru: { translation: ru },
  es: { translation: es },
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLocale(),
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: TIER_A_LANGUAGES,
    
    interpolation: {
      escapeValue: false,
    },
    
    // Missing key handling
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`[i18next] Missing: "${key}" for ${lngs.join(', ')}`);
      }
    },
    
    returnNull: false,
    returnEmptyString: false,
    
    react: {
      useSuspense: false,
    },
  });

/**
 * Sync i18next language with LocaleManager
 */
export function syncI18nextLanguage(lang) {
  if (!lang) return;
  
  // Only change if different and supported
  if (i18n.language !== lang && TIER_A_LANGUAGES.includes(lang)) {
    i18n.changeLanguage(lang);
  }
}

/**
 * Get current i18next language
 */
export function getI18nextLanguage() {
  return i18n.language;
}

export default i18n;
